module.exports = __webpack_public_path__ + "files/03fa10c34ac21040b0e0deb403bf8939.png";